/* LP content sections: mobile comparison slider and scroll-driven benefits timeline. */

(() => {
  const initCompare = (chart) => {
    if (chart.dataset.ready) return;
    chart.dataset.ready = 'true';
    const section = chart.closest('.lp-compare');
    const track = chart.querySelector('[data-compare-track]');
    const nav = section.querySelector('[data-compare-nav]');
    if (!track || !nav) return;

    const cols = [...track.querySelectorAll('[data-compare-col]')];
    const dots = [...nav.querySelectorAll('.lp-compare__dot')];
    const prev = nav.querySelector('[data-compare-prev]');
    const next = nav.querySelector('[data-compare-next]');

    const current = () => Math.round(track.scrollLeft / (cols[0]?.offsetWidth || 1));
    const update = () => {
      const index = current();
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      prev.disabled = index <= 0;
      next.disabled = index >= cols.length - 1;
    };
    const go = (index) => {
      const clamped = Math.max(0, Math.min(index, cols.length - 1));
      track.scrollTo({ left: clamped * cols[0].offsetWidth });
    };

    prev.addEventListener('click', () => go(current() - 1));
    next.addEventListener('click', () => go(current() + 1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    update();
  };

  const initTimeline = (list) => {
    if (list.dataset.ready) return;
    list.dataset.ready = 'true';
    const steps = [...list.querySelectorAll('[data-timeline-step]')];
    if (!steps.length) return;

    const setActive = (active) => {
      steps.forEach((step, i) => {
        step.classList.toggle('is-active', i === active);
        step.classList.toggle('is-reached', i <= active);
        step.classList.toggle('is-line-dark', i < active);
      });
    };

    // A step becomes active once its top passes 60% of the viewport height.
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        const line = window.innerHeight * 0.6;
        let active = 0;
        steps.forEach((step, i) => {
          if (step.getBoundingClientRect().top < line) active = i;
        });
        setActive(active);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  };

  // Clinical chart: bars grow and callouts fade in once, when 30% of the chart is visible.
  const initGraph = (chart) => {
    if (chart.dataset.ready) return;
    chart.dataset.ready = 'true';
    if (window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    chart.classList.add('is-armed');
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        requestAnimationFrame(() => chart.classList.add('is-in-view'));
      },
      { threshold: 0.3 }
    );
    observer.observe(chart);
  };

  // FAQs: the first question starts open on desktop only (mobile design shows all closed).
  const initFaq = (item) => {
    if (item.dataset.ready) return;
    item.dataset.ready = 'true';
    if (window.matchMedia('(min-width: 990px)').matches) item.open = true;
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-open-desktop]').forEach(initFaq);
    root.querySelectorAll('[data-lp-compare]').forEach(initCompare);
    root.querySelectorAll('[data-lp-timeline]').forEach(initTimeline);
    root.querySelectorAll('[data-lp-graph]').forEach(initGraph);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
